import { useTranslation } from '@platform/i18n';
import { BrandMark } from './BrandMark.tsx';
import { Wordmark, type WordmarkSurface } from './Wordmark.tsx';
import styles from './Shell.module.css';

export const BrandLockup = ({ surface }: { surface: WordmarkSurface }) => {
  const { t } = useTranslation();
  const appName = t('shell.appName');
  return (
    <div className={styles['brand']}>
      <BrandMark name={appName} />
      <Wordmark name={appName} surface={surface} />
    </div>
  );
};
